module.exports = __webpack_public_path__ + "img/furukawaw.fdb95d6a.svg";